import menus from '@/utils/menus';
import {
  getDeviceTypes,
} from '@/api/projects';

const localState = {
  menus: [],
  activeMenu: {},
  activeSubmenu: {},
  activeDevice: null,
  checkGroup: 0,
};

const mutations = {
  setMenus(state, list) {
    state.menus = list;
  },
  setMenu(state, menu) {
    state.activeMenu = menu;
  },
  setSubmenu(state, submenu) {
    state.activeSubmenu = submenu || {};
  },
  setCurrentDevice(state, device) {
    state.activeDevice = device;
  },
  setCheckGroup(state, group) {
    state.checkGroup = group;
  },
};
const actions = {
  async initMenus({ commit, rootState }) {
    const projectId = rootState.project.currentProject.id;
    getDeviceTypes(projectId).then((res) => {
      const deviceTypes = res.data.deviceTypes;
      const newMenus = menus.filter(item => deviceTypes.includes(item.id));
      commit('setMenus', newMenus);

      // 默认选中第一个
      // if (!newMenus.length) return; // 没有类型 退出
      // const newMenu = newMenus[0];
      // commit('setMenu', newMenu);

      // // 默认选中第一个
      // commit('setSubmenu', (newMenu.submenus && newMenu.submenus[0]) ? newMenu.submenus[0] : {});
      // commit('setCurrentDevice', null);

      // 顺便设置到device module
      commit('device/setDeviceTypes', { deviceTypes: newMenus.map(item => item.id) }, { root: true });
    });
  },
};

export default {
  mutations,
  actions,
  state: localState,
  namespaced: true,
};

